import { useState } from "react";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Plus } from "lucide-react";
import { useCatalogsStore } from "../../../store/Catalogs";

interface CategoryDialogProps {
	catalogId: string;
	catalogName: string;
	isCustomCatalog: boolean;
}

export const CategoryDialog: React.FC<CategoryDialogProps> = ({
	catalogId,
	catalogName,
	isCustomCatalog,
}) => {
	const [open, setOpen] = useState(false);
	const [name, setName] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const addCustomCategory = useCatalogsStore((state) => state.addCustomCategory);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		
		if (!name.trim()) {
			return;
		}

		setIsSubmitting(true);
		try {
			await addCustomCategory(catalogId, name.trim(), isCustomCatalog);
			setOpen(false);
			setName("");
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleOpenChange = (newOpen: boolean) => {
		setOpen(newOpen);
		if (!newOpen) {
			setName("");
		}
	};

	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogTrigger asChild>
				<Button size="sm" variant="outline" className="h-7 px-2 flex items-center gap-1">
					<Plus className="h-3 w-3" />
					<span className="text-xs">Neue Kategorie</span>
				</Button>
			</DialogTrigger>
			<DialogContent className="sm:max-w-[425px]">
				<form onSubmit={handleSubmit}>
					<DialogHeader>
						<DialogTitle>Neue Kategorie erstellen</DialogTitle>
						<DialogDescription>
							Erstellen Sie eine neue Kategorie für den Katalog "{catalogName}".
						</DialogDescription>
					</DialogHeader>
					<div className="grid gap-4 py-4">
						<div className="grid grid-cols-4 items-center gap-4">
							<Label htmlFor="name" className="text-right">
								Name
							</Label>
							<Input
								id="name"
								value={name}
								onChange={(e) => setName(e.target.value)}
								className="col-span-3"
								placeholder="z.B. Spezialleistungen"
								required
								autoFocus
							/>
						</div>
					</div>
					<DialogFooter>
						<Button
							type="button"
							variant="outline"
							onClick={() => handleOpenChange(false)}
							disabled={isSubmitting}
						>
							Abbrechen
						</Button>
						<Button type="submit" disabled={isSubmitting || !name.trim()}>
							{isSubmitting ? "Erstelle..." : "Erstellen"}
						</Button>
					</DialogFooter>
				</form>
			</DialogContent>
		</Dialog>
	);
};